<form #form>
    <button id="file-select-button" mat-button class="primary" (click)="fileselect.click()">{{title}}</button>
    <input #fileselect id="file-select" type="file" [multiple]="multiple" (change)="onValidation($event)" accept="{{accept}}" hidden>
</form>